import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './Salon.css';

// Renders a 'YYYY-MM-DD' date with the same weekday + date styling used in the Time Sheet's
// day cells (small uppercase weekday, bold date), for visual consistency across Time & PTO.
const StyledDate = ({ date, showWeekday = true }) => {
  const { getDayName, formatWeddingDate } = useLanguage();

  if (!date) return '—';

  const [year, month, day] = date.split('-').map(Number);
  const dayOfWeek = new Date(year, month - 1, day).getDay();

  return (
    <div className="time-off-day-cell pto-date">
      {showWeekday && <span className="time-off-day-weekday">{getDayName(dayOfWeek, true)}</span>}
      <span className="time-off-day-date">{formatWeddingDate(date)}</span>
    </div>
  );
};

export default StyledDate;
